/**
 * TranslationsKeys
 * Centralized registry of translation keys used across the application.
 */
class TranslationsKeys {
    // ─── Common Form & Validation Keys ─────────────────────────────────
    static REQUIRED_FIELD = 'web.requiredField';
    static MAX_CHARACTERS = 'web.maxCharacters';
    static FILE_SIZE_LIMIT = 'web.fileSizeLimit';
    static INVALID_FILE_TYPE = 'web.invalidFileType';
    static NO_FILE_SELECTED = 'web.noFileSelected';
    static UPLOAD_FILE = 'web.uploadFile';
    static REMOVE = 'web.remove';
    static YES = 'web.yes';
    static NO = 'web.no';
    static CLOSE = 'web.close';
    static CANCEL = 'web.cancel';
    static SUBMIT = 'web.submit';
    static SUBMITTING = 'web.submitting';
    static HOME = 'web.home';
    static BACK = 'web.back';

    // ─── User & Participant Info Keys ──────────────────────────────────
    static FULL_NAME = 'web.fullName';
    static FULL_NAME_AR = 'web.fullNameAr';
    static FULL_NAME_EN = 'web.fullNameEn';
    static ENTER_FULL_NAME = 'web.enterFullName';
    static EMAIL = 'web.email';
    static ENTER_EMAIL = 'web.enterEmail';
    static MOBILE_NO = 'web.mobileNo';
    static IDENTITY_DOCUMENT = 'web.identityDocument';
    static ID_COPY = 'web.idCopy';
    static ID_FILE = 'web.idFile';
    static ID_OR_PASSPORT = 'web.idOrPassport';

    // ─── Workshop Registration Keys ───────────────────────────────────
    static WORKSHOP = 'web.workshop';
    static WORKSHOP_REGISTRATION = 'web.workshopRegistration';
    static SADDLE_WORKSHOP = 'web.saddleWorkshop';
    static SADDLE_WORKSHOP_TITLE = 'web.saddleWorkshopTitle';
    static SADDLE_WORKSHOP_SUBTITLE = 'web.saddleWorkshopSubtitle';
    static PARTICIPANT_INFO = 'web.participantInfo';
    static REQUIRED_FIELDS_NOTE = 'web.requiredFieldsNote';
    static ALLOWED_FILES_NOTE = 'web.allowedFilesNote';
    static SUBMIT_REGISTRATION = 'web.submitRegistration';
    static REGISTRATION_SUCCESSFUL = 'web.registrationSuccessful';
    static REGISTRATION_SUCCESS_MESSAGE = 'web.registrationSuccessMessage';
    static REGISTER_ANOTHER_PARTICIPANT = 'web.registerAnotherParticipant';
    static INVALID_EMAIL = 'web.invalidEmailAddress';
    static VALID_FULL_NAME_REQUIRED = 'web.validFullNameRequired';
    static UPLOAD_ID_REQUIRED = 'web.uploadIdRequired';
    static ERROR_IN_SUBMITTING = 'web.errorInSubmitting';
}

export default TranslationsKeys;
